module.exports = __webpack_public_path__ + "static/media/our-values.011df3c5.jpg";